import {
  deleteAdminV1OrgProductTypesId,
  patchAdminV1OrgProductTypesId,
  postAdminV1OrgProductTypes,
  type CreateProductTypeRequest,
  type ProductType,
  type ProductTypeUpdated,
  type UpdateProductTypeRequest,
} from '@nucleus-commerce/api-client/admin';

/** Writes for product types; the list and detail reads stay in `dictionary-api.ts`. */
export const productTypesApi = {
  create: (body: CreateProductTypeRequest): Promise<ProductType> =>
    postAdminV1OrgProductTypes(body),
  update: (id: string, body: UpdateProductTypeRequest): Promise<ProductTypeUpdated> =>
    patchAdminV1OrgProductTypesId({ id }, body),
  remove: (id: string): Promise<void> => deleteAdminV1OrgProductTypesId({ id }),
};
